import adsBgImg from '../assets/ads/adsBg.png'

const ADS_BACKGROUND_VARIANTS = [adsBgImg]

export const getAdsBackgroundImage = () => {
  return ADS_BACKGROUND_VARIANTS[
    Math.floor(Math.random() * ADS_BACKGROUND_VARIANTS.length)
  ]
}
